<template>
  <div class="px-6 py-4 bg-white h-[4.5rem] box-border">
    <slot />
  </div>
</template>
